(function () {
	const header = () => {
		const body = document.querySelector("body");
		const header = document.querySelector(".shopify-section-header");
		const searchModal = document.querySelector(".search-modal");
		const stickyHeader = document.querySelector(".header-wrapper");
		const headerTop = document.querySelector(".header-top");
		const headerLogo = document.querySelector(".header-top__logo");
		const headerRight = document.querySelector(".header-top__right");
		const headerDetails = document.querySelector(".menu-drawer-container");
		const megaMenuLinks = document.querySelectorAll(".header-mega-menu__have-submenu__list .first-link");
		const megaMenuItem = document.querySelectorAll(".header__megamenu-item");
		const megaSubmenus = document.querySelectorAll('.header-mega-menu__submenu');
		const headerSimpleMenuLinks = document.querySelectorAll('.header__submenu--simple .header__submenu-li');
		const topLevelDisclosureSubmenus = document.querySelectorAll('.header .list-menu--inline > li > .header__submenu.list-menu--disclosure');

		const renderMegaSubmenuColumnSeparators = () => {
			if (window.innerWidth < 1100) {
				megaSubmenus.forEach((submenu) => {
					submenu.querySelectorAll('.header-mega-menu__col-separator').forEach((item) => item.remove());
				});
				return;
			}

			megaSubmenus.forEach((submenu) => {
				submenu.querySelectorAll('.header-mega-menu__col-separator').forEach((item) => item.remove());

				const items = Array.from(submenu.querySelectorAll(':scope > li'));
				if (items.length < 9) return;

				const submenuRect = submenu.getBoundingClientRect();
				const columns = new Map();

				items.forEach((item) => {
					const itemRect = item.getBoundingClientRect();
					const columnLeft = Math.round(itemRect.left - submenuRect.left);
					const currentRight = columns.get(columnLeft);
					const itemRight = itemRect.right - submenuRect.left;

					if (currentRight === undefined || itemRight > currentRight) {
						columns.set(columnLeft, itemRight);
					}
				});

				const sortedColumns = Array.from(columns.entries()).sort((a, b) => a[0] - b[0]);
				if (sortedColumns.length < 2) return;

				sortedColumns.slice(0, -1).forEach(([, rightEdge], index) => {
					const nextColumnLeft = sortedColumns[index + 1][0];
					const separator = document.createElement('span');
					separator.className = 'header-mega-menu__col-separator';
					separator.style.left = `${(rightEdge + nextColumnLeft) / 2}px`;
					submenu.appendChild(separator);
				});
			});
		};

		const alignDisclosureSubmenus = () => {
			if (!headerTop || !headerLogo || !headerRight || window.innerWidth < 1100) {
				topLevelDisclosureSubmenus.forEach((submenu) => {
					const parentLi = submenu.parentElement;
					if (parentLi) {
						parentLi.style.removeProperty('--header-submenu-gap');
					}
					submenu.style.left = '';
					submenu.style.right = '';
					submenu.style.top = '';
					submenu.style.width = '';
					submenu.style.minWidth = '';
				});
				return;
			}

			const logoRect = headerLogo.getBoundingClientRect();
			const rightRect = headerRight.getBoundingClientRect();
			const start = Math.round(logoRect.right);
			const end = Math.round(rightRect.left);

			if (end <= start) return;

			const headerTopBottom = Math.round(headerTop.getBoundingClientRect().bottom);

			topLevelDisclosureSubmenus.forEach((submenu) => {
				const parentLi = submenu.parentElement;
				if (!parentLi) return;

				const liRect = parentLi.getBoundingClientRect();
				const leftOffset = Math.round(start - liRect.left);
				const topOffset = Math.round(headerTopBottom - liRect.top);
				const hoverGap = Math.max(Math.round(topOffset - liRect.height), 0);
				const width = Math.round(end - start);

				parentLi.style.setProperty('--header-submenu-gap', `${hoverGap}px`);

				submenu.style.left = `${leftOffset}px`;
				submenu.style.right = 'auto';
				submenu.style.top = `${topOffset}px`;
				submenu.style.width = `${width}px`;
				submenu.style.minWidth = `${width}px`;
			});
		};

		headerSimpleMenuLinks.forEach((link) => {
			link.addEventListener('mouseenter', (e) => {
				headerSimpleMenuLinks.forEach((el) => {
					if (el === e.target) {
						el.querySelector('.header__submenu').classList.add('show-submenu');
						el.querySelector('.header__submenu').classList.remove('remove-submenu');
					} else {
						el.querySelector('.header__submenu').classList.remove('show-submenu');
						el.querySelector('.header__submenu').classList.add('remove-submenu');
					}

				})
			})
		})

		alignDisclosureSubmenus();
		renderMegaSubmenuColumnSeparators();
		if (window.__canvasDisclosureSubmenuAlignHandler) {
			window.removeEventListener('resize', window.__canvasDisclosureSubmenuAlignHandler);
			window.removeEventListener('load', window.__canvasDisclosureSubmenuAlignHandler);
		}
		window.__canvasDisclosureSubmenuAlignHandler = alignDisclosureSubmenus;
		window.addEventListener('resize', alignDisclosureSubmenus);
		window.addEventListener('load', alignDisclosureSubmenus);

		if (window.__canvasMegaSubmenuSeparatorHandler) {
			window.removeEventListener('resize', window.__canvasMegaSubmenuSeparatorHandler);
			window.removeEventListener('load', window.__canvasMegaSubmenuSeparatorHandler);
		}
		window.__canvasMegaSubmenuSeparatorHandler = renderMegaSubmenuColumnSeparators;
		window.addEventListener('resize', renderMegaSubmenuColumnSeparators);
		window.addEventListener('load', renderMegaSubmenuColumnSeparators);

		let disableHover = false;
		let activeItem = null;

		megaMenuItem.forEach((item) => {

			item.addEventListener("mouseenter", () => {
				if (disableHover) return;

				stickyHeader.classList.add("mega-menu-open");
				if (header.classList.contains("header-overlay")) {
					header.classList.remove("color-inverse");
				}
				document.querySelector('.header-mega-menu__overlay').classList.add('active');
				document.querySelectorAll(".header__account details").forEach(item => item.removeAttribute('open'));
				document.querySelectorAll(".disclosure__button").forEach(button => button.setAttribute("aria-expanded", "false"));
				document.querySelectorAll(".disclosure__list").forEach(list => list.setAttribute("hidden", ""));
				document.querySelectorAll(".header__submenu").forEach(item => item.style.zIndex = -2);
			})

			item.parentElement.addEventListener("mouseleave", () => {
				if (disableHover) return;
				stickyHeader.classList.remove("mega-menu-open");
				if (header.classList.contains("header-overlay") && !searchModal.classList.contains('active') && !header.classList.contains('shopify-section-header-sticky')) {
					// setTimeout(() => {
						header.classList.add("color-inverse");
					// }, 200);
				}
				document.querySelector('.header-mega-menu__overlay').classList.remove('active');
				document.querySelectorAll(".header__submenu").forEach(item => item.style.zIndex = 'unset');
			})

			 item.addEventListener('click', (e) => {
				const href = item.getAttribute('href'); 
				if (href && href === '#') {
					console.log("link", href)
					disableHover = true;
					activeItem = item;
					e.preventDefault(); 
				}
			});
			
		})

		
		document.addEventListener('click', (e) => {
			const clickedItem = activeItem?.contains(e.target)
			const href = activeItem?.getAttribute('href')

			if (href && href === '#') {
				if (clickedItem) return
				disableHover = false
				if (
					header.classList.contains('header-overlay') &&
					!searchModal.classList.contains('active') &&
					!header.classList.contains('shopify-section-header-sticky')
				) {
					header.classList.add('color-inverse')
				}
				document
					.querySelector('.header-mega-menu__overlay')
					.classList.remove('active')
				document
					.querySelectorAll('.header__submenu')
					.forEach((item) => (item.style.zIndex = 'unset'))
				activeItem = null
			}
		})

		megaMenuLinks.forEach((link) => {
			link.addEventListener("mouseenter", (event) => {
				megaMenuLinks[0].classList.add('remove-sub-links');
				megaMenuLinks.forEach((item) => {
					item.classList.remove('show-sub-links');
				})
				event.target.classList.add('show-sub-links');
			})
		})
		
		const headerIsAlwaysSticky =
			header
				.querySelector(".header-wrapper")
				.getAttribute("data-sticky-type") === "always";

		if (headerDetails) {
			headerDetails.addEventListener("toggle", function (e) {
				const colorScheme =
					this.querySelector("#menu-drawer").dataset.colorScheme;
				header.classList.toggle(colorScheme);
			});
		}
		document.addEventListener("keyup", (e) => {
			if (e.key === "Escape") {
				header.classList.remove("shopify-section-header-sticky", "animate");
				body.classList.remove("overflow-hidden");
			}
		});

		document.addEventListener("scroll", () => {
			let scrollTop = window.scrollY;
			if (scrollTop > header.offsetHeight && headerIsAlwaysSticky) {
				header.classList.add("fixed", "animate", "color-background-1");
				if (header.classList.contains('header-overlay')) {
					header.classList.remove('color-inverse')
				}
			} else if (scrollTop <= header.offsetHeight && headerIsAlwaysSticky) {
				header.classList.remove("color-background-1");
				if (header.classList.contains('header-overlay')) {
					header.classList.add('color-inverse')
				}
			}
		});

		const addBackground = () => {
			if (
				header.classList.contains("color-inverse") &&
				!header.classList.contains("shopify-section-header-sticky")
			) {
				header.classList.remove("color-inverse");
			}
		};

		const removeBackground = () => {
			if (document.body.classList.contains("overflow-hidden-tablet")) {
				return;
			}

			if (
				header.classList.contains("header-overlay") &&
				!header.classList.contains("shopify-section-header-sticky")
			) {
				header.classList.add("color-inverse");
			}
		};

		//header.addEventListener("mouseenter", addBackground);

		//header.addEventListener("focus", addBackground);

		//header.addEventListener("focusin", addBackground);

		//header.addEventListener("mouseleave", removeBackground);

		//header.addEventListener("focusout", removeBackground);
	};

	header();

	document.addEventListener("shopify:section:load", header);
	document.addEventListener("shopify:section:unload", header);
	document.addEventListener("shopify:section:reorder", header);
})();
